import EventEmitter from 'eventemitter3';
import { MediaSegment } from 'redux/modules/entities';
import {
  MaybeSegmentedVideoPlayerProps,
  OverriddenEvent,
  SupportedEventMap,
} from './types';

const OVERRIDDEN_EVENTS: ReadonlyArray<keyof SupportedEventMap> = [
  'ended',
  'seeked',
  'timeupdate',
] as const;

export function calculateDurationMillis(segments: MediaSegment[] = []): number {
  return segments[segments.length - 1]?.adjustedEndMillis ?? 0;
}

export function createEventEmitter() {
  return new EventEmitter<OverriddenEvent>();
}

export function isOverriddenEvent(
  event: keyof SupportedEventMap,
): event is keyof OverriddenEvent {
  return OVERRIDDEN_EVENTS.includes(event);
}

export function isSourceSegmented(props: MaybeSegmentedVideoPlayerProps) {
  return props.segments && props.segments.length > 0;
}
